const $ = jQuery.noConflict();
import 'slick-carousel';

'use strict';

/** @description Helper Classes for creating base config options. */
class SliderBaseConfig {
	constructor(slidesToShow = 4, slidesToScroll = 1, speed = 1000, rows = 0) {
		this.slidesToShow = slidesToShow;
		this.slidesToScroll = slidesToScroll;
		this.speed = speed;
		this.rows = rows;
	}
}

const Sliders = {
	/** @description Cache dom and strings. */
	$domSlider: $('.js-slider'),
	$domSliderProductRecommend: $('.js-product-more-like-slider'),
	$domSliderInterestedIn: $('.js-product-interested-in-slider'),
	$domSliderTrustedBy: $('.js-product-slider'),
	$domSliderTestimonials: $('.js-product-testimonials-slider'),
	$domSliderLogo: $('.js-slider-logo'),
	$domSliderHero: $('.js-hero__slider'),
	$domMobileImageSlider: $('.js-hero__mobile-slider'),


	/** @description Initialize. */
	init: function() {
		this.initGallerySlider();
		this.initRecommendSlider();
		this.initInterestedInSlider();
		this.initTrustedBySlider();
		this.initTestimonialsSlider();
		this.initSliderLogo();
		this.initSliderHero();
		this.initMobileImageSlider();
	},

	/** @description Set and run gallery slider. */
	initGallerySlider: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: true,
			autoplay: true,
			arrows: false,
			responsive: [
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2
					}
				}
			]
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSlider, config);
	},
	initRecommendSlider: function() {
		const baseConfig = new SliderBaseConfig(4, 1, 1000, 0);
		const extraConfig = {
			infinite: true,
			arrows: true,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1
					}
				}
			]
		};
		const config = {
			...baseConfig,
			...extraConfig
		};

		// Loop through each slider
		$('.js-product-more-like-slider').each((index, sliderEl) => {
			const $slider = $(sliderEl);
			// Find arrows relative to this slider (assuming structure allows this)
			const $nextArrow = $slider.parent().find('.product-more-like__header').find('.js-product-more-like-slider-next');
			const $prevArrow = $slider.parent().find('.product-more-like__header').find('.js-product-more-like-slider-prev');

			// Extend config with specific arrows
			const instanceConfig = {
				...config,
				nextArrow: $nextArrow,
				prevArrow: $prevArrow
			};

			// Init slider
			this.runSlider($slider, instanceConfig);

			// Function to check and toggle arrow visibility per instance
			const checkRecommendSliderArrows = function() {
				const totalSlides = $slider.find('.slick-slide').not('.slick-cloned').length;
				let slidesToShow = baseConfig.slidesToShow; // Default slides to show

				// Adjust slidesToShow based on responsive settings
				const windowWidth = window.innerWidth;
				if (instanceConfig.responsive) {
					instanceConfig.responsive.forEach(breakpoint => {
						if (windowWidth <= breakpoint.breakpoint) {
							slidesToShow = breakpoint.settings.slidesToShow;
						}
					});
				}

				// Show/hide arrows for this instance
				if (totalSlides <= slidesToShow) {
					$nextArrow.hide();
					$prevArrow.hide();
				} else {
					$nextArrow.show();
					$prevArrow.show();
				}
			};

			// Initial check
			checkRecommendSliderArrows();

			// Check on window resize (for responsive changes)
			$(window).on('resize', checkRecommendSliderArrows);
		});
	},
	initInterestedInSlider: function() {
		const baseConfig = new SliderBaseConfig(3, 1, 1000, 0);
		const extraConfig = {
			infinite: true,
			arrows: true,
			nextArrow: $('.js-product-interested-in-slider-next'),
			prevArrow: $('.js-product-interested-in-slider-prev'),
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1
					}
				}
			]
		};
		const config = {
			...baseConfig,
			...extraConfig
		};
		this.runSlider(this.$domSliderInterestedIn, config);
	},
	initTrustedBySlider: function() {
		const baseConfig = new SliderBaseConfig(4, 1, 1000, 0);
		const extraConfig = {
			infinite: true,
			arrows: true,
			centerMode: true,
			nextArrow: $('.js-product-slider-next'),
			prevArrow: $('.js-product-slider-prev'),
			responsive: [
				{
					breakpoint: 1480,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 680,
					settings: {
						slidesToShow: 1
					}
				}
			]
		};
		const config = {
			...baseConfig,
			...extraConfig
		};
		this.runSlider(this.$domSliderTrustedBy, config);
	},
	initTestimonialsSlider: function() {
		const baseConfig = new SliderBaseConfig(1, 1, 1000, 0);
		const config = {
			...baseConfig,
			infinite: false,
			arrows: true,
			prevArrow: $('.js-product-testimonials-slider-prev'),
			nextArrow: $('.js-product-testimonials-slider-next'),
			dots: false,
			adaptiveHeight: false
		};

		this.$domSliderTestimonials.on('init', (event, slick) => {
			this.updateCounter(slick, 0); // Set initial counter
		});

		this.$domSliderTestimonials.on('afterChange', (event, slick, currentSlide) => {
			this.updateCounter(slick, currentSlide);
		});

		this.$domSliderTestimonials.slick(config);
	},
	updateCounter: function(slick, currentSlide = 0) {
		const totalSlides = slick.slideCount;
		const current = totalSlides > 0 ? currentSlide + 1 : 1;
		$('.js-product-testimonials-slider-count').text(`${current}/${totalSlides}`);
	},
	initSliderLogo: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			// infinite: true,
			// autoplay: false,
			// slidesToShow: 6,
			// arrows: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 0,
			speed: 5000,
			centerMode: true,
			cssEase: 'linear',
			slidesToShow: 1,
			slidesToScroll: 1,
			variableWidth: true,
			initialSlide: 1,
			arrows: false,
			// responsive: [
			// 	{
			// 		breakpoint: 991,
			// 		settings: {
			// 			slidesToShow: 3
			// 		}
			// 	},
			// 	{
			// 		breakpoint: 767,
			// 		settings: {
			// 			slidesToShow: 2
			// 		}
			// 	}
			// ]
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSliderLogo, config);
	},

	initMobileImageSlider: function() {
		const $slider = this.$domMobileImageSlider;
		if (! $slider.length) return;

		const config = {
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 800,
			rows: 0,
			infinite: true,
			arrows: false,
			dots: true,
		};

		const mq = window.matchMedia('(max-width: 767px)');

		const handleChange = (e) => {
			if (e.matches) {
				if (! $slider.hasClass('slick-initialized')) {
					$slider.slick(config);
				}
			} else {
				if ($slider.hasClass('slick-initialized')) {
					$slider.slick('unslick');
				}
			}
		};

		mq.addEventListener('change', handleChange);
		handleChange(mq);
	},

	initSliderHero: function() {
		const $slider = this.$domSliderHero;
		if (!$slider.length) return;

		const config = {
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 1000,
			rows: 0,
			infinite: true,
			arrows: false,
			dots: true,
			autoplay: true,
			autoplaySpeed: 3500,
		};

		const $imageOnlySlides = $slider.find('.hero__wrap--image-only');

		// Store original DOM index of each image-only slide before any detach
		const slidePositions = [];
		$imageOnlySlides.each(function() {
			slidePositions.push($(this).index());
		});

		const mq = window.matchMedia('(max-width: 767px)');

		const handleChange = (e) => {
			if ($slider.hasClass('slick-initialized')) {
				$slider.slick('unslick');
			}
			if (e.matches) {
				$imageOnlySlides.detach();
			} else {
				$imageOnlySlides.each(function(i) {
					const targetIndex = slidePositions[i];
					const $children = $slider.children();
					if (targetIndex >= $children.length) {
						$slider.append(this);
					} else {
						$(this).insertBefore($children.eq(targetIndex));
					}
				});
			}
			$slider.slick(config);
		};

		mq.addEventListener('change', handleChange);
		handleChange(mq);
	},

	/** @description Loop through sliders and run. */
	runSlider: ($slider, config) => {
		$slider.each((i, el) => {
			$(el).slick(config);
		});
	}
};

export default Sliders;
